import { BloodworkNote } from '.';

export class BloodworkNotes {
  notes?: BloodworkNote[]; 

  constructor(bloodworkNotes?: BloodworkNotes | any) {
    if (bloodworkNotes && bloodworkNotes.notes) {
      this.notes = bloodworkNotes.notes;
    } else {
      this.notes = [];
    }
  }

  findNote(section: string): BloodworkNote {
    return this.notes.find((note)=>{
      return note.section === section;
    })
  }

  addNote(section: string, text: string): BloodworkNote {
    const bloodworkNote = new BloodworkNote({ section, text });
    this.notes.push(bloodworkNote);
    return bloodworkNote;
  }
}
